import * as classNames from "classnames"
import { AddCommentFormWrapper, AddCommentFormRenderProps } from "../addCommentFormWrapper";
import { ArticleCommentWrapper, ArticleCommentRender, ArticleCommentRenderProps } from "../articleCommentWrapper"
import { getTalkbackNumberView } from "../../articleSocialShare1280Component/articleSocialShareNew1280";

import { MutamArticleCommentsPopupRenderProps } from "../mutamArticleCommentsPropsWrapper";
import { getTranslation } from "../translations"
import { AddCommentFormUI2026 } from "./ynetAddCommentFormUI2026";
import { ArticleCommentUI2026 } from "./ynetArticleCommentUI2026";
import { disablePageRefresh, enablePageRefresh } from "../../../../../siteWidgets/siteWidgetUtils";

interface ArticleCommentsPopupProps {
    props: MutamArticleCommentsPopupRenderProps
}
interface PopupState {
    isSortMenuVisible: boolean
}

export class DesktopArticleCommentsPopupUI extends React.Component<ArticleCommentsPopupProps, PopupState> {
    constructor(props: ArticleCommentsPopupProps) {
        super(props);
        this.state = {
            isSortMenuVisible: false

        };
    }
    private commentsWrapperRef: HTMLElement | null = null;
    private lastScrollTop: number = 0;
    private focusTrapHandler: ((e: KeyboardEvent) => void) | null = null;

    private handleSiblingsAriaHidden = (isHidden: boolean) => {
        const popup = document.getElementById('ArticleCommentsPopup');
        if (!popup) return;
        
        let parent = popup.parentElement;
        if (!parent) return;
        
        Array.from(parent.children).forEach(el => {
            if (el !== popup) {
                if (isHidden) {
                    el.setAttribute('aria-hidden', 'true');
                } else {
                    el.removeAttribute('aria-hidden');
                }
            }
        });
    }

    componentDidUpdate(prevProps: ArticleCommentsPopupProps) {
        const { isAllCommentsPopupVisable, isAddCommentFormVisible } = this.props.props;
        const wasPopupVisible = prevProps.props.isAllCommentsPopupVisable;

        // When popup opens, dispatch event to recalculate line heights
        if (isAllCommentsPopupVisable && !wasPopupVisible) {
            
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(new CustomEvent('commentsPopupOpened'));
                    const syntheticEvent = {
                        target: { value: this.props.props.sortSelection }
                    };
                    this.props.props.handleSortSelection(syntheticEvent);
                }
           

            // Dispatch again after animation completes
            setTimeout(() => {
                if (typeof window !== 'undefined') {
                    window.dispatchEvent(new CustomEvent('commentsPopupOpened'));
                    // Activate focus trap after popup is visible
                    this.trapFocus();
                    // Set aria-hidden on siblings
                    this.handleSiblingsAriaHidden(true);
                }
            }, 0);
            disablePageRefresh()

            // Add scroll listener
            this.attachScrollListener();
        }
        else if (!isAllCommentsPopupVisable && wasPopupVisible) {
            enablePageRefresh()
            this.removeScrollListener();
            // Remove focus trap when popup closes
            this.removeFocusTrap();
            // Remove aria-hidden from siblings
            this.handleSiblingsAriaHidden(false);
        }
    }

    componentWillUnmount() {
        this.removeScrollListener();
        this.removeFocusTrap();
    }

    private trapFocus = () => {
        const popup = document.getElementById('ArticleCommentsPopup');
        if (!popup) return;

        const focusableSelectors = `
            button, [href], input, textarea, select, 
            [tabindex]:not([tabindex="-1"])
        `;

        const focusableElements = popup.querySelectorAll(focusableSelectors);
        if (focusableElements.length === 0) return;

        const firstEl = focusableElements[0] as HTMLElement;
        const lastEl = focusableElements[focusableElements.length - 1] as HTMLElement;

        this.focusTrapHandler = (e: KeyboardEvent) => {
            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    // Shift + Tab
                    if (document.activeElement === firstEl) {
                        e.preventDefault();
                        lastEl.focus();
                    }
                } else {
                    // Tab
                    if (document.activeElement === lastEl) {
                        e.preventDefault();
                        firstEl.focus();
                    }
                }
            }
        };

        popup.addEventListener('keydown', this.focusTrapHandler);
    }

    private removeFocusTrap = () => {
        const popup = document.getElementById('ArticleCommentsPopup');
        if (popup && this.focusTrapHandler) {
            popup.removeEventListener('keydown', this.focusTrapHandler);
            this.focusTrapHandler = null;
        }
    }

    private attachScrollListener = () => {
        const commentsWrapper = document.querySelector('#ArticleCommentsPopup .commentsWrapper') as HTMLElement;
        if (commentsWrapper) {
            this.commentsWrapperRef = commentsWrapper;
            commentsWrapper.addEventListener('scroll', this.handleScroll);
            commentsWrapper.addEventListener('scroll', () => {
                this.setState(() => ({
                    isSortMenuVisible: false
                }));
            });
        }
    }

    private removeScrollListener = () => {
        if (this.commentsWrapperRef) {
            this.commentsWrapperRef.removeEventListener('scroll', this.handleScroll);
            this.commentsWrapperRef = null;
        }
    }

    private handleScroll = () => {
        const { isAddCommentFormVisible, handleCloseCommentForm } = this.props.props;

        if (isAddCommentFormVisible && this.commentsWrapperRef) {
            const currentScrollTop = this.commentsWrapperRef.scrollTop;
            
            // Only close form when scrolling down
            if (currentScrollTop > this.lastScrollTop) {
                // Check if form is visible on screen
                const formElement = document.querySelector('#ArticleCommentsPopup .mainFormWrapper .AddCommentFormUI2026') as HTMLElement;
                
                if (formElement) {
                    const formRect = formElement.getBoundingClientRect();
                    const wrapperRect = this.commentsWrapperRef.getBoundingClientRect();
                    
                    // Check if form is out of view (scrolled past the top of the wrapper)
                    const isFormVisible = formRect.bottom > wrapperRect.top && formRect.top < wrapperRect.bottom;
                    
                    if (!isFormVisible) {
                        handleCloseCommentForm();
                    }
                }
            }
            
            this.lastScrollTop = currentScrollTop;
        }
    }

    private handleOnAddCommentBtnPress = (e) => {
        const { handleFormVisibility } = this.props.props
        handleFormVisibility()
            if (this.commentsWrapperRef) {
            this.commentsWrapperRef.scrollTop = 0;
        }
        // Scroll to form after it becomes visible
        setTimeout(() => {
            const formElement = document.querySelectorAll('#ArticleCommentsPopup .mainFormWrapper .AddCommentFormUI2026')[0];
            if (formElement) {
                formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
    }
    private toggleSortMenu = () => {
        this.setState((prevState) => ({
            isSortMenuVisible: !prevState.isSortMenuVisible
        }));
    }
    private handleSelectionSort = (e) => {
        const { handleSortSelection } = this.props.props
        const value = e.currentTarget.getAttribute('value');
        // Create a synthetic event object that matches what the parent expects
        const syntheticEvent = {
            target: { value: value }
        };
        handleSortSelection(syntheticEvent)
        this.setState({ isSortMenuVisible: false });
    }

    render() {
        const { lang, articleId, comments, IdOfLastTalkbackExpandedByUser, updateArticleCommentsStorageState, areAllCommentsExpanded, numOfComments, showFormWhenEmpty,
            isAddCommentFormVisible, handleCloseCommentForm, isAllCommentsPopupVisable, handleCommentsPopupClose, handleCommentsPopupVisibility, isFirmaMobileWeb, handleSortSelection, sortSelection,
            isPopupClose, loadMoreComments, hasMore, postId, domain } = this.props.props

        const commentsPopupClasses = classNames({
            "ArticleCommentsPopup": true,
            "hide": !isAllCommentsPopupVisable && !isPopupClose,
            "fadeIn": isAllCommentsPopupVisable,
            "fadeOut": isPopupClose,
        })
        const addCommentBtnClasses = classNames({
            "addCommentBtn": true,
            "fadeIn": !isAddCommentFormVisible,
            "hide": isAddCommentFormVisible,
        })

        let ArticleCommentRender: ArticleCommentRender;
        ArticleCommentRender = (props: ArticleCommentRenderProps) => <ArticleCommentUI2026 props={{ ...props, notPopupMode: false }} />;
        let sortSelectionLabel = "";
        if (sortSelection == "end_to_start") {
            sortSelectionLabel = getTranslation(lang, "End To Start");
        } else if (sortSelection == "start_to_end") {
            sortSelectionLabel = getTranslation(lang, "Start To End");
        } else if (sortSelection == "recommended") {
            sortSelectionLabel = getTranslation(lang, "Recommended");
        }
        return (
            <div>
                <section id="ArticleCommentsPopup" className={`${commentsPopupClasses} ${postId ? postId : ''}`} role="dialog" aria-modal="true" tabIndex={-1} aria-label={getTranslation(lang, "Comments")}>
                    <button className="popupCloseIcon" onClick={handleCommentsPopupClose}></button>
                    <div className="commentsTopBar">
                        <div className="headlineTitle">{getTranslation(lang, "Comments")}</div>
                        <div className="commentsCountContainer">
                            {`${getTalkbackNumberView(numOfComments.toString())} ${getTranslation(lang, "Comments")}`}

                        </div>
                        <div role="button" className={addCommentBtnClasses} aria-label={getTranslation(lang, "New Comment(premium)")} onClick={this.handleOnAddCommentBtnPress}>{getTranslation(lang, "New Comment(premium)")}</div>

                    </div>

                    <div className="commentsWrapper">
                        <AddCommentFormWrapper
                            render={(props: AddCommentFormRenderProps) => <AddCommentFormUI2026 props={{ ...props, shouldTitleBeHidden: true }} />}
                            isAddCommentFormVisible={isAddCommentFormVisible}
                            lang={lang}
                            articleId={articleId}
                            formType={"NEW"}
                            postId={postId}
                            shouldTitleBeHidden={true}
                            handleCloseCommentForm={handleCloseCommentForm}
                            isFirstComment={showFormWhenEmpty && numOfComments === 0}
                        />
                        <div className="sortSelectWrapper">
                            <div className="sortSelect" role="button" tabIndex={0} aria-label={getTranslation(lang, "Sort By")} onClick={this.toggleSortMenu}>   <span>{getTranslation(lang, "Sort By")} </span>{sortSelectionLabel}   <div className={this.state.isSortMenuVisible ? "menuToggler toClose" : "menuToggler toOpen"} /></div>
                            <div className={classNames("optionsMenu", { "isVisible": this.state.isSortMenuVisible })}>
                                <div className="sortOption" onClick={this.handleSelectionSort} id="logoutDesktopYnet" value="end_to_start">{getTranslation(lang, "End To Start")}</div>
                                <div className="sortOption" onClick={this.handleSelectionSort} id="logoutDesktopYnet" value="start_to_end">{getTranslation(lang, "Start To End")}</div>
                                <div className="sortOption" onClick={this.handleSelectionSort} id="logoutDesktopYnet" value="recommended">{getTranslation(lang, "Recommended")}</div>
                            </div>
                        </div>
                        <ol className="commentsContainer">

                            {comments.map((comment, i) =>
                                <li key={`comment_${comment.id}`}>
                                    <ArticleCommentWrapper
                                        render={ArticleCommentRender}
                                        lang={lang}
                                        IdOfLastTalkbackExpandedByUser={IdOfLastTalkbackExpandedByUser}
                                        handleUpdateArticleCommentsStorageState={updateArticleCommentsStorageState}
                                        isAutoExpanded={areAllCommentsExpanded}
                                        articleId={articleId}
                                        comment={comment}
                                        isFirma={null}
                                        postId={postId}
                                        domain={domain}
                                        isNewTemplate2026={true}
                                        isFirmaMobileWeb={isFirmaMobileWeb}
                                        handleCommentsPopupClose={handleCommentsPopupClose}
                                        isAllCommentsPopupVisable={isAllCommentsPopupVisable}
                                    />
                                </li>
                            )}
                        </ol>

                        {hasMore &&
                            <div className="showMoreCommentsButton" onClick={e => loadMoreComments()}>
                                {getTranslation(lang, "Show more")}
                            </div>}

                    </div>
                </section>

            </div>
        )
    }
}